import { useEffect, useState } from "react";
import { useCustomerAttributeConstraint } from "./useCustomerAttributeConstraint";
import { SurchargeEventCalculation } from "../shared/models/SurchargeEventCalculation";
import { SurchargeEventCalculationRun } from "../shared/models/SurchargeEventCalculationRun";
import { ReviewNewChargesApi } from "../shared/api/ReviewNewCharges.api";
import { GetLastestAction } from "../shared/business/ReviewNewCharges";

export const useSurchargeSelectBoxState = () => {
  const { loadCustomerAttributeConstraints } = useCustomerAttributeConstraint();

  const [calculatedEvents, setCalculatedEvents] = useState([] as SurchargeEventCalculation[]);
  const [selectedSurchargeEvent, setSelectedSurchargeEvent] = useState({} as SurchargeEventCalculation);
  const [calculatedEventRuns, setCalculatedEventRuns] = useState([] as SurchargeEventCalculationRun[]);
  const [selectedCalculatedEventRun, setSelectedCalculatedEventRun] = useState({} as SurchargeEventCalculationRun);

  useEffect(() => {
    loadingData();
  }, []);

  const loadingData = async () => {
    await loadCustomerAttributeConstraints();

    var calculatedEvents = await ReviewNewChargesApi.listCalculatedEvents();
    if (!calculatedEvents) {
      return;
    }

    setCalculatedEvents(calculatedEvents);

    var lastActionName = GetLastestAction().name;
    var index = calculatedEvents.findIndex((item) => item.name === lastActionName);
    if (index === -1) index = 0;
    setSelectedSurchargeEvent(calculatedEvents[index]);
    await processSurchargeEventChanged(calculatedEvents[index].id);
  };

  const handleSurchargeEventChange = async (e: SurchargeEventCalculation) => {
    setSelectedSurchargeEvent(e);
    await processSurchargeEventChanged(e.id);
  };

  const handleSurchargeEventRunChange = async (e: SurchargeEventCalculationRun) => {
    setSelectedCalculatedEventRun(e);
  };

  const processSurchargeEventChanged = async (id: string) => {
    var data = await ReviewNewChargesApi.listCalculatedEventRuns(id);
    if (!data) {
      return;
    }

    setCalculatedEventRuns(data);
    setSelectedCalculatedEventRun(data[0]);
  };

  return {
    calculatedEvents,
    selectedSurchargeEvent,
    handleSurchargeEventChange,
    calculatedEventRuns,
    selectedCalculatedEventRun,
    handleSurchargeEventRunChange,
    processSurchargeEventChanged,
  };
};
